import { render, staticRenderFns } from "./AccountAgent.vue?vue&type=template&id=8f457736&scoped=true"
import script from "./AccountAgent.vue?vue&type=script&lang=js"
export * from "./AccountAgent.vue?vue&type=script&lang=js"
import style0 from "./AccountAgent.vue?vue&type=style&index=0&id=8f457736&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f457736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f457736')) {
      api.createRecord('8f457736', component.options)
    } else {
      api.reload('8f457736', component.options)
    }
    module.hot.accept("./AccountAgent.vue?vue&type=template&id=8f457736&scoped=true", function () {
      api.rerender('8f457736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/agent/AccountAgent.vue"
export default component.exports